import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import Navigation from "@/components/sections/Navigation";
import FooterSection from "@/components/sections/FooterSection";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import HomePage from "@/components/pages/HomePage";
import OutboundEngineBuildPage from "@/components/pages/OutboundEngineBuildPage";
import CustomWorkflowsPage from "@/components/pages/CustomWorkflowsPage";
import IndustryPage, { IndustriesPage } from "@/components/pages/IndustryPage";
import WorkflowPage, { WorkflowLibraryPage } from "@/components/pages/WorkflowPage";
import InsightsPage from "@/components/pages/InsightsPage";
import InsightPostPage from "@/components/pages/InsightPostPage";
import AuditPage from "@/components/pages/AuditPage";
import ReferralPage from "@/components/pages/ReferralPage";
import TermsPage from "@/components/pages/TermsPage";
import PrivacyPage from "@/components/pages/PrivacyPage";
import NotFoundPage from "@/components/pages/NotFoundPage";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LegacyPostRedirect() {
  const { slug } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/insights/${slug}${search}`} replace />;
}

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <MotionConfig reducedMotion="user">
    <div className="bg-[#F4E9D8] text-[#1F1F1C] font-figtree overflow-x-hidden min-h-screen flex flex-col">
      <ScrollToTop />
      <Toaster position="top-center" richColors />
      <Navigation mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/outbound-engine-build" element={<OutboundEngineBuildPage />} />
          <Route path="/custom-workflows" element={<CustomWorkflowsPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/industries/:slug" element={<IndustryPage />} />
          <Route path="/workflows" element={<WorkflowLibraryPage />} />
          <Route path="/workflows/:slug" element={<WorkflowPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<InsightPostPage />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          <Route path="/blog" element={<Navigate to="/insights" replace />} />
          <Route path="/blog/:slug" element={<LegacyPostRedirect />} />
          <Route path="/referral-program" element={<Navigate to="/referral" replace />} />
          <Route path="/contact" element={<Navigate to="/audit" replace />} />
          <Route path="/stack-audit" element={<Navigate to="/audit" replace />} />
          <Route path="/pricing" element={<Navigate to="/outbound-engine-build" replace />} />
          <Route path="/team-training" element={<Navigate to="/outbound-engine-build" replace />} />
          <Route path="/switch-from-an-agency" element={<Navigate to="/outbound-engine-build" replace />} />
          <Route path="/faq" element={<Navigate to="/" replace />} />
          <Route path="/partners" element={<Navigate to="/" replace />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <FooterSection />
      <WhatsAppFloat />
    </div>
    </MotionConfig>
  );
}

export default App;
